<template>
  <!-- 我要签到弹窗 -->
  <van-popup v-model="showUploadDia"
             position="right"
             :style="{ width: '100%', height: '100%' }"
             class="IA_Sign_photoUpload_dialog">
    <van-nav-bar :title="'拍照上传'"
                 left-arrow
                 @click-left="showUploadDia = false"
                 :fixed="true">
    </van-nav-bar>
    <div class="pop_content">
      <div class="iptline">
        <div class="text">
          <div class="name">附件</div>
          <div class="tip">最多3张</div>
        </div>
        <van-uploader v-model="fileList"
                      multiple
                      :lazy-load="true"
                      :max-count="3"
                      :accept="'image/*'"
                      :max-size="10 * 1024 * 1024"
                      :preview-size="'20vw'"
                      :before-read="asyncBeforeRead"
                      @oversize="onOversize"></van-uploader>
      </div>
      <div class="pop_footer">
        <div class="button txt1"
             @click="closeSIDia('cancel')">{{ '取消'}}</div>
        <div class="button txt2"
             @click="closeSIDia('confirm')">{{ '确定'}}</div>
      </div>
    </div>
  </van-popup>

</template>

<script>
import { Toast } from 'vant'
import Compressor from 'compressorjs'
export default {
  props: {
    event: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      showUploadDia: false,
      fileList: [],
    }
  },
  watch: {
    showUploadDia (n) {
      if (!n)
      {
        this.fileList = []
      }
    }
  },
  methods: {
    // 返回 Promise
    asyncBeforeRead (file) {
      console.log(file, 'fileasyncBeforeRead');
      // let list = []
      return new Promise((resolve, reject) => {
        // for (const ele of file)
        // {
        //   let it = null
        //   let quality = 0.6
        //   if (ele.size >= 1024 * 1024 * 0.5 && 1024 * 1024 * 1 > ele.size)
        //   {
        //     quality = 0.8
        //   }
        //   if (ele.size >= 1024 * 1024 * 1 && 1024 * 1024 * 2 > ele.size)
        //   {
        //     quality = 0.6
        //   }
        //   if (ele.size >= 1024 * 1024 * 2 && 1024 * 1024 * 5 > ele.size)
        //   {
        //     quality = 0.4
        //   }
        //   if (ele.size >= 1024 * 1024 * 5)
        //   {
        //     quality = 0.2
        //   }
        //   ele = this.compressorImage(ele, 'file', quality)
        //   console.log(ele, 'file22334455');
        //   // list.push(ele)
        // }
        // console.log(file, 'filefuck');
        // this.fileList = list
        resolve(file);
      });
    },
    // 超出大小
    onOversize (file) {
      // console.log(file);
      // this.$message.error('文件大小不能超过 10M')
      Notify({
        type: 'danger',
        message: '文件大小不能超过 10M'
      })
    },
    // 拍照上传弹窗回调
    async closeSIDia (action) {
      console.log(this.fileList, 'fileList22334455');
      let fileList = []
      if (action == 'confirm')
      {
        if (this.fileList.length <= 0)
        {
          Toast.fail('至少上传一张照片');
          return
        }
        // 如果是图片，则先压缩，防止提交失败
        for (const it of this.fileList)
        {
          let ele = it.file
          let quality = 0.6
          if (ele.size >= 1024 * 1024 * 0.5 && 1024 * 1024 * 1 > ele.size)
          {
            quality = 0.8
          }
          if (ele.size >= 1024 * 1024 * 1 && 1024 * 1024 * 2 > ele.size)
          {
            quality = 0.6
          }
          if (ele.size >= 1024 * 1024 * 2 && 1024 * 1024 * 5 > ele.size)
          {
            quality = 0.4
          }
          if (ele.size >= 1024 * 1024 * 5)
          {
            quality = 0.2
          }
          ele = await this.compressorImage(ele, 'file', quality)
          // console.log(ele, 'file22334455');
          fileList.push(ele)
        }
        // 转换为base64
        let fffff = []
        for (const it of fileList)
        {
          await this.getBase64(it).then(res => {
            fffff.push(res)
          })
        }
        this.$emit('returnToAttachment', fffff)
        this.showUploadDia = false
      } else
      {
        this.showUploadDia = false
      }
    },
    // 文件转base64
    getBase64 (file) {
      // const tempFile = file
      // const type = tempFile.type
      // const size = tempFile.size
      // // const newName = new Date().getTime() + tempFile.name
      // const newName = Math.round(Math.random() * 1000000) + tempFile.name
      // let uploadFile = new File([tempFile], newName, { type, size })
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    // 压缩图片
    compressorImage (image, backType, quality) {
      return new Promise((resolve, reject) => {
        new Compressor(image, {
          quality: quality || 0.8,
          success (result) {
            let lastIndexOf = image.name.lastIndexOf('.')
            // let name = image.name.substr(0, lastIndexOf) + '.png'
            let name = image.name
            // console.log(image, 'image.type', name);
            let file = new File([result], name, { type: image.type })
            // console.log(file, 'filefilefile');
            if (!backType || backType == 'blob')
            {
              resolve(result)
            } else if (backType == 'file')
            {
              resolve(file)
            } else
            {
              resolve(file)
            }
          },
          error (err) {
            console.log('图片压缩失败---->>>>>', err)
            reject(err)
          }
        })
      })
    }
  }

}
</script>

<style lang="less" scoped>
// 拍照弹窗
.IA_Sign_photoUpload_dialog {
  height: 100vh;
  width: 100%;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .pop_content {
    // overflow: auto;
    position: relative;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .iptline {
      height: calc(100% - 100px);
      overflow-y: auto;
      padding: 20px;
      .text {
        margin-bottom: 30px;
        color: #323233;
        .name {
          font-size: 36px;
        }
        .tip {
          font-size: 28px;
        }
      }
    }
    .pop_footer {
      width: 100%;
      height: 100px;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 32px;
      display: flex;
      justify-content: center;
      .button {
        height: 80px;
        line-height: 80px;
        width: 80%;
        text-align: center;
        // background: #2b8df0;
        // color: #fff;
        font-size: 36px;
        border-radius: 12px;
      }
      .txt1 {
        color: #323233;
      }
      .txt2 {
        color: #0782f5;
      }
    }
  }
}
</style>